import { useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import primeClient from "../../../../axios/primeClient";
import { createContext, useContext, useState, useEffect, useRef } from "react";
import { Card } from "../../../../Components/Card";
import * as echarts from "echarts";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { Colors } from "../../../../constants/Colors";
const DataContext = createContext();

export const DetailComponent = () => {
  const { componentId, resource, type } = useParams();
  // function roundToDecimals(value, decimals = 2) {
  //   console.log("value", value);
  //   const factor = Math.pow(10, decimals);
  //   console.log("factor", factor);
  //   console.log("res" , value < 0 ? Math.ceil(value * factor) / factor : Math.floor(value * factor) / factor);

  //   return value < 0
  //     ? Math.ceil(value * factor) / factor // Use Math.ceil for negative numbers
  //     : Math.floor(value * factor) / factor; // Use Math.floor for positive numbers
  // }
  function roundToDecimals(value, decimals = 2) {
    // console.log("value", value);
    // if (!value){
    //   return value;
    // }
    if (value.toFixed(2) !== "0.00" && value.toFixed(2) !== "-0.00") {
      return value.toFixed(2);
    } 
    for (let i = 2; i < value.toString().length; i++) {
      if (value.toString()[i] !== "0") {
        return value.toFixed(i+1);
      }
    }
    return value;
    
    
  }
  

  
  

  const { data, isLoading, error } = useFetch({
    url: `/v1/apps/detail/component?network_id=${componentId}&type=${type}&duration=day&component=${resource === "cpu_system" || resource === "cpu_user" ? "cpu" : resource}`,
    client: primeClient,
  });

  // using data, isLoading, error but different variables name
  const {
    data: dataWeek,
    isLoading: isLoadingWeek,
    error: errorWeek,
  } = useFetch({
    
    url: `/v1/apps/detail/component?network_id=${componentId}&type=${type}&duration=week&component=${resource === "cpu_system" || resource === "cpu_user" ? "cpu" : resource}`,
    client: primeClient,
  });

  const { t, i18n } = useTranslation();

  const [isToday, setIsToday] = useState(true);
  const [isAnomalyClicked, setIsAnomalyClicked] = useState(false);

  const formatResource = (resource) => {
    switch (resource) {
      case "cpu":
        return "CPU";
      case "memory":
        return "Memory";
      case "storage":
        return "Storage";
      case "cpu_user":
        return "CPU User";
      case "cpu_system":
        return "CPU System";
      default:
        return resource;
    }
  };


  const toggleToday = () => {
    setIsToday((prev) => !prev);
  };

  const clickAnomaly = () => {
    setIsAnomalyClicked(true);
  };

  const closeAnomaly = () => {
    setIsAnomalyClicked(false);
  };

  useEffect(() => {
    closeAnomaly();
  }, []);
  return (
    <DataContext.Provider
      value={{
        data,
        isLoading,
        error,
        dataWeek,
        isLoadingWeek,
        errorWeek,
        isToday,
        i18n,
        t,
        resource,
        type,
        formatResource,
        roundToDecimals,
      }}
    >
      <div
        style={{
          padding: "2rem 1rem 1rem 1rem",
          width: "100%",
          height: "100%",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            fontSize: "1.25rem",
            marginBottom: "0.5rem",
            fontWeight: "bold",
          }}
        >
          {t("prime.detailAnalysis.deviceCapacityandQoS.detailAnalysis", {
            componentType:
              formatResource(resource),
          })}
        </div>
        <DeviceDescriptionCard resource={resource} />
        <Card style={{ padding: "1rem", marginTop: "1rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                textAlign: "center",
              }}
            >
              {t(
                "prime.detailAnalysis.deviceCapacityandQoS.performanceAnalysis"
              )}
            </p>
            <Picker isToday={isToday} toggleToday={toggleToday} />
          </div>

          {isToday ? (
            isLoading || !data ? (
              <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
                Loading...
              </p>
            ) : error ? (
              <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
                {error.message}
              </p>
            ) : data.error ? (
              <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
                {data.message}
              </p>
            ) : resource === "cpu_user" || resource === "cpu_system" ? (
                <PerformanceChart       
                  data={data?.usage.map((d) => d[resource].toFixed(2))}
                  labels={data?.usage.map((d) => d.time.slice(11, 16))}
                  anomalies={data.is_anomaly[resource] === "no" ? [] : data?.anomalies[resource]}
                  type={resource}
                    
                />
              ) : (
              <PerformanceChart
                data={data?.usage.map((d) => d[`${resource}_usage`].toFixed(2))}
                labels={data?.usage.map((d) => d.time.slice(11, 16))}
                anomalies={data.anomalies}
                type={resource}
              />
            )
            
             
          ) : isLoadingWeek || !dataWeek  ? (
            <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
              Loading...
            </p>
          ) : errorWeek ? (
            <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
              Error - {errorWeek.message}
            </p>
          ) : dataWeek.error ? (
            <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
              Error - {dataWeek.message}
            </p>
          ) : resource === "cpu_user" || resource === "cpu_system" ? (
            <PerformanceChart
              data={dataWeek?.usage.map((d) => d[resource].toFixed(2))}
              labels={dataWeek?.usage.map((d) => d.time.slice(0, 16))}
              anomalies={dataWeek?.anomalies[0][resource]}
              type={resource}
            />
          ) :
          (
            <PerformanceChart
              data={dataWeek?.usage.map((d) => d[`${resource}_usage`].toFixed(2))}
              labels={dataWeek?.usage.map((d) => d.time.slice(0, 16))}
              anomalies={dataWeek?.anomalies}
              type={resource}
            />
          )}
        

        <TrendTableCard clickAnomaly={clickAnomaly} />
        <br /> <hr /> <br />
        <SummaryAnalysisCard resource={resource} />
        <br /> <hr /> <br />
        <RecommendationCard resource={resource} />
        </Card>
      </div>
      {isAnomalyClicked && (
        <FloatingAnomalies resource={resource} closeAnomaly={closeAnomaly} />
      )}
    </DataContext.Provider>
  );
};

const DeviceDescriptionCard = ({ resource }) => {
  const { data, isLoading, error, formatResource, type } = useContext(DataContext);

  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "600px",
        backgroundColor: Colors.primary100,
        color: Colors.white,
        padding: "0.5rem 1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <div>
          {isLoading || error || data.error ? "Device Name" : 
          type==="server" ? data.server_name :
          data.node_inventory_name}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {formatResource(resource)}{" "}
          | {isLoading || error || data.error ? "Node Inventory Name" : data.index}
        </div>
      </div>
    </Card>
  );
};

const Picker = ({ isToday, toggleToday }) => {
  const { t, i18n } = useContext(DataContext);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        borderBlock: "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <button
        style={{
          padding: "0.5rem 0.5rem",
          backgroundColor: isToday ? Colors.primary100 : Colors.white,
          color: isToday ? Colors.white : Colors.primary100,
          border: "none",
          cursor: "pointer",
          borderTopLeftRadius: "0.5rem",
          borderBottomLeftRadius: "0.5rem",
          fontWeight: isToday ? "bold" : "normal",
          fontSize: "0.8rem",
        }}
        onClick={toggleToday}
      >
        {t("prime.detailAnalysis.deviceCapacityandQoS.today")}
      </button>
      <button
        style={{
          padding: "0.5rem 0.5rem",
          backgroundColor: !isToday ? Colors.primary100 : Colors.white,
          color: !isToday ? Colors.white : Colors.primary100,
          border: "none",
          cursor: "pointer",
          borderTopRightRadius: "0.5rem",
          borderBottomRightRadius: "0.5rem",
          fontWeight: !isToday ? "bold" : "normal",
          fontSize: "0.8rem",
        }}
        onClick={toggleToday}
      >
        {t("prime.detailAnalysis.deviceCapacityandQoS.thisWeek")}
      </button>
    </div>
  );
};

const PerformanceChart = ({ data, labels, anomalies, type }) => {
  const chartRef = useRef(null); // Create a ref for the chart container

  useEffect(() => {
    if (chartRef.current) {
      // Initialize the chart
      const myChart = echarts.init(chartRef.current);
      let markPoints = [];

      if (anomalies !== undefined) {
        
      markPoints = anomalies.map((anomaly) => ({
        name: "Anomaly", 
        xAxis: labels.indexOf(anomaly.time.slice(0,16)), 
        yAxis: type === "cpu_user" || type=== "cpu_system" ? anomaly[type].toFixed(2) : anomaly[`${type}_usage`].toFixed(2), // CPU value for the anomaly
        // value: "anomaly", // Display the value in the tooltip
        // itemStyle: {
        //   color: "red", // Highlight anomalies with red markers
        // },
      }));
      console.log("markPoints", markPoints);
    } else {
      markPoints = [];
    }

      // Set the chart options
      myChart.setOption({
        tooltip: {
          trigger: "axis",

        },
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: data,
            type: "line",
            markPoint: {
              data: markPoints,
            },

          },
        ],
      });

      // Cleanup on component unmount
      return () => {
        myChart.dispose();
      };
    }
  }, [data, labels, anomalies]); // Re-initialize the chart when data or labels change

  return (
    <div
      ref={chartRef} // Assign the ref to the container
      style={{ width: "100%", height: 300 }}
    ></div>
  );
};

const TrendTableCard = ({ clickAnomaly }) => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    t,
    i18n,
    resource,
    roundToDecimals,
  } = useContext(DataContext);

  return (
      <div
          style={{
              width: "100%",
              
          }}
      >
          
          <table
              style={{
                  width: "100%",
                  borderCollapse: "collapse",
              }}
          >
              <thead>
                  <tr
                  >
                      <th
                       style={{ backgroundColor: Colors.neutral10,padding: "0.5rem 1rem", marginBottom: "5px", fontSize: "0.8rem", fontWeight: 700, borderBottomLeftRadius: "5px", borderTopLeftRadius: "5px" }}
                      >
                        {t("prime.detailAnalysis.deviceCapacityandQoS.trendPattern")}
                      </th>
                      <th
                      style={{ backgroundColor: Colors.neutral10,  padding: "0.5rem 1rem", marginBottom: "5px", fontSize: "0.8rem", fontWeight: 700 }}
                      >
                        {t("prime.detailAnalysis.deviceCapacityandQoS.trendSlope")}
                      </th>
                      <th
                      style={{ backgroundColor: Colors.neutral10,padding: "0.5rem 1rem", marginBottom: "5px", fontSize: "0.8rem", fontWeight: 700, borderBottomRightRadius: "5px", borderTopRightRadius: "5px" }}
                      >
                        {t("prime.detailAnalysis.deviceCapacityandQoS.anomaly")}
                      </th>
                  </tr>
              </thead>
              <tbody>
                {isToday ? (
                  isLoading || !data ? (
                      <tr style={{fontSize: '0.8rem'}}>
                          <td colSpan="4">Loading...</td>
                      </tr>
                  ) : error ? (
                      <tr style={{fontSize: '0.8rem'}}>
                          <td colSpan="4">{error.message}</td>
                      </tr>
                  ) : data.error ? (
                      <tr style={{fontSize: '0.8rem'}}>
                          <td colSpan="4">{data.message}</td>
                      </tr>
                  )
                  : (
                          <tr style={{fontSize: '0.8rem'}}>
                            {resource === "cpu_system" || resource === "cpu_user" ? (
                              <>
                              <td style={{ textAlign: "center" }}>{data.trend_pattern[0][resource].pattern}</td>
                              <td style={{ textAlign: "center" }}>{roundToDecimals(data.trend_pattern[0][resource].trend_slope)}%</td>
                              <td style={{ textAlign: "center" }}>{
                              data.is_anomaly[0][resource] === 'no' ? 'No' :
                              <div style={{color: Colors.primary100, underline: 'true', cursor: 'pointer'}}
                              onClick={clickAnomaly}
                              >
                                {t("prime.detailAnalysis.deviceCapacityandQoS.view")}
                              </div>
                              }</td>

                              </>
                            ): (
                              <>
                              <td style={{ textAlign: "center" }}>{data.trend_pattern.pattern}</td>
                              <td style={{ textAlign: "center" }}>{roundToDecimals(data.trend_pattern.trend_slope)}%</td>
                              <td style={{ textAlign: "center" }}>{
                              data.is_anomaly === 'no' ? 'No' :
                              <div style={{color: Colors.primary100, underline: 'true', cursor: 'pointer'}}
                              onClick={clickAnomaly}
                              >
                                {t("prime.detailAnalysis.deviceCapacityandQoS.view")}
                              </div>
                              }</td>
                              </>
                            )}
                              
                          </tr>
                  )
                ) : (
                  isLoadingWeek || !dataWeek ? (
                    <tr style={{fontSize: '0.8rem'}}>
                        <td colSpan="4">Loading...</td>
                    </tr>
                  ) : errorWeek ? (
                    <tr style={{fontSize: '0.8rem'}}>
                        <td colSpan="4">Error: {errorWeek.message}</td>
                    </tr>
                  ) : dataWeek.error ? (
                    <tr style={{fontSize: '0.8rem'}}>

                        <td colSpan="4">Error: {dataWeek.message}</td>
                    </tr>
                  ) :
                  (
                    resource === "cpu_system" || resource === "cpu_user" ? (
                    <>
                    <tr style={{fontSize: '0.8rem'}}>
                        <td style={{ textAlign: "center" }}>{dataWeek.trend_pattern[0][resource].pattern}</td>
                        <td style={{ textAlign: "center" }}>{roundToDecimals(dataWeek.trend_pattern[0][resource].trend_slope)}%</td>
                        <td style={{ textAlign: "center" }}>{
                        dataWeek.is_anomaly[0][resource] === 'no' ? 'No' :
                        <div style={{color: Colors.primary100, underline: 'true', cursor: 'pointer'}}
                        onClick={clickAnomaly}
                        >
                          {t("prime.detailAnalysis.deviceCapacityandQoS.view")}
                        </div>
                        }</td>
                    </tr>
                    </>) : (
                      <>
                    <tr style={{fontSize: '0.8rem'}}>
                        <td style={{ textAlign: "center" }}>{dataWeek.trend_pattern.pattern}</td>
                        <td style={{ textAlign: "center" }}>{roundToDecimals(dataWeek.trend_pattern.trend_slope)}%</td>
                        <td style={{ textAlign: "center" }}>{
                        dataWeek.is_anomaly === 'no' ? 'No' :
                        <div style={{color: 'blue', underline: 'true', cursor: 'pointer'}}
                        onClick={clickAnomaly}
                        >
                          {t("prime.detailAnalysis.deviceCapacityandQoS.view")}
                        </div>
                        }</td>
                    </tr>
                    </>
                    )
                  )
                )}
              </tbody>
          </table>
      </div>
  );
};

const SummaryAnalysisCard = ({ resource }) => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    i18n,
    t, formatResource, type,roundToDecimals
  } = useContext(DataContext);
  return (
    <div style={{ }}>
      <p style={{ fontWeight: "bold", fontSize: "1.1rem", color: "black" }}>
        {t("prime.detailAnalysis.deviceCapacityandQoS.summaryAnalysis.header")}
      </p>
      <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
        {isToday ? (
          isLoading || !data ? (
            "Loading..."
          ) : error ? (
            `${error.message}`
          ) : data.error ? (
             data.message
          ) 
          : i18n.language === "id" ? (
            <p>
              <strong>
                Kapasitas{" "}
                {formatResource(resource)}{" "}
              </strong>{" "}
              Anda hari ini dalam kondisi { resource === "cpu_system" || resource === "cpu_user" ? data.mean_usage[0][`${resource}_category`] :
              data.usage_condition_category}.
              Rata-rata Usage{" "}
              {formatResource(resource)}{" "}
              pada {data.index} <strong>hari ini</strong> adalah{" "}
              {resource === "cpu_system" || resource === "cpu_user" ? data.mean_usage[0][`${resource}_mean`] :
               data.mean_usage}%, usage{" "}
              {formatResource(resource)}{" "}
              memiliki trend <strong>kenaikan</strong> sebesar{" "}
              <strong>{
              resource === "cpu_system" || resource === "cpu_user" ? roundToDecimals(data.trend_pattern[0][resource].trend_slope) :
              roundToDecimals(data.trend_pattern.trend_slope)}% per hari</strong> dengan
              pola trend yaitu <strong>{ resource === "cpu_system" || resource === "cpu_user" ? data.trend_pattern[0][resource].pattern :
              data.trend_pattern.pattern}</strong>,
              { resource === "cpu_system" || resource === "cpu_user" ? data.is_anomaly[0][resource] === "no" :
              data.is_anomaly === "no"
                ? " tidak ditemukan anomali pada data hari ini"
                : " terdapat anomali pada data hari ini"}
              .
            </p>
          ) : (
            <p>
              The{" "}
              <strong>
                {formatResource(resource)}{" "}
                Capacity
              </strong>{" "}
              today is in {
              resource === "cpu_system" || resource === "cpu_user" ? data.mean_usage[0][`${resource}_category`] :
              data.usage_condition_category} condition. The average
              usage of{" "}
              {formatResource(resource)}{" "}
              on {
              data.index} <strong>today</strong> is { resource === "cpu_system" || resource === "cpu_user" ? data.mean_usage[0][`${resource}_mean`] :
                data.mean_usage}%, the
              usage of{" "}
              {formatResource(resource)}{" "}
              has a<strong> increasing</strong> trend of{" "}
              <strong>{ resource === "cpu_system" || resource === "cpu_user" ? roundToDecimals(data.trend_pattern[0][resource].trend_slope) :
              roundToDecimals(data.trend_pattern.trend_slope)}% per day</strong> with a
              trend pattern of <strong>{
              resource === "cpu_system" || resource === "cpu_user" ? data.trend_pattern[0][resource].pattern :
              data.trend_pattern.pattern}</strong>,
              {
              resource === "cpu_system" || resource === "cpu_user" ? data.is_anomaly[0][resource] === "no" :
              data.is_anomaly === "no"
                ? " no anomalies found in today's data"
                : " there is an anomaly in today's data"}
              .
            </p>
          )
        ) : isLoadingWeek || !dataWeek ? (
          "Loading..."
        ) : errorWeek ? (
          `${errorWeek.message}`
        ) : dataWeek.error ? (
          `${dataWeek.message}`
        )
        : i18n.language === "id" ? (
          <p>
            <strong>
              Kapasitas{" "}
              {formatResource(resource)}{" "}
            </strong>{" "}
            Anda dalam 1 minggu terakhir dalam kondisi{" "}
            { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.mean_usage[0][`${resource}_category`] :
            dataWeek.usage_condition_category}. Rata-rata Usage{" "}
            {formatResource(resource)}{" "}
            pada {dataWeek.index} <strong>minggu ini</strong> adalah{" "}
            { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.mean_usage[0][`${resource}_mean`] :
            dataWeek.mean_usage}%, usage{" "}
            {formatResource(resource)}{" "}
            memiliki trend <strong>kenaikan</strong> sebesar{" "}
            <strong>{ resource === "cpu_system" || resource === "cpu_user" ? roundToDecimals(dataWeek.trend_pattern[0][resource].trend_slope) :
           roundToDecimals(dataWeek.trend_pattern.trend_slope)}% per hari</strong>{" "}
            dengan pola trend yaitu{" "}
            <strong>{ resource === "cpu_system" || resource === "cpu_user" ? dataWeek.trend_pattern[0][resource].pattern :
            dataWeek.trend_pattern.pattern}</strong>,
            { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.is_anomaly[0][resource] === "no" :
            dataWeek.is_anomaly === "no"
              ? " tidak ditemukan anomali pada data minggu ini"
              : " terdapat anomali pada data minggu ini"}
            .
          </p>
        ) : (
          <p>
            The{" "}
            <strong>
              {formatResource(resource)}{" "}
              Capacity
            </strong>{" "}
            in this week is in { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.mean_usage[0][`${resource}_category`] :
            dataWeek.usage_condition_category} condition.
            The average usage of{" "}
            {formatResource(resource)}{" "}
            on {dataWeek.index} <strong>this week</strong> is{" "}
            { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.mean_usage[0][`${resource}_mean`] :
            dataWeek.mean_usage}%, the usage of{" "}
            {formatResource(resource)}{" "}
            has a<strong> increasing</strong> trend of{" "}
            <strong>{ resource === "cpu_system" || resource === "cpu_user" ? dataWeek.trend_pattern[0][resource].trend_slope :
            dataWeek.trend_pattern.trend_slope}% per day</strong> with
            a trend pattern of <strong>{ resource === "cpu_system" || resource === "cpu_user" ? dataWeek.trend_pattern[0][resource].pattern :
            dataWeek.trend_pattern.pattern}</strong>
            ,
            { resource === "cpu_system" || resource === "cpu_user" ? dataWeek.is_anomaly[0][resource] === "no" :
            dataWeek.is_anomaly === "no"
              ? " no anomalies found in this week's data"
              : " there is an anomaly in this week's data"}
            .
          </p>
        )}
      </p>
    </div>
  );
};

const RecommendationCard = () => {
  const { resource, t, formatResource } = useContext(DataContext);
  return (
    <div style={{ }}>
      <p style={{ fontWeight: "bold", fontSize: "1.1rem", color: "black" }}>
        {t("prime.detailAnalysis.deviceCapacityandQoS.recommendation")}
      </p>
      <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
        {t("prime.detailAnalysis.deviceCapacityandQoS.recommendationText", {
          component:
            formatResource(resource),
        })}
      </p>
    </div>
  );
};

const FloatingAnomalies = ({ resource, closeAnomaly }) => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    i18n,
    formatResource,
  } = useContext(DataContext);

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 999,
          pointerEvents: "auto",
        }}
        onClick={closeAnomaly}
      ></div>

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          cursor: "pointer",
          width: window.innerWidth > 600 ? "400px" : "80%",
        }}
      >
        <Card style={{ padding: "1rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "black",
              }}
            >
              {i18n.language === "id" ? (
                <p>
                  Anomali{" "}
                  {formatResource(resource)}
                </p>
              ) : (
                <p>
                  {resource === "cpu"
                    ? resource.toUpperCase()
                    : resource.charAt(0).toUpperCase() + resource.slice(1)}{" "}
                  Anomalies
                </p>
              )}
            </div>
            <button
              onClick={closeAnomaly}
              style={{
                border: "none",
                backgroundColor: "white",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              X
            </button>
          </div>
          <table style={{ width: "100%" }}>
            <thead>
              <tr
                style={{
                  backgroundColor: Colors.neutral10,
                  borderRadius: "5px",
                }}
              >
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>
                  {i18n.language === "id" ? "Waktu" : "Time"}
                </th>
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>
                  {i18n.language === "id" ? "Penggunaan" : "Usage"}
                </th>
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>
                  {i18n.language === "id" ? "Deviasi" : "Deviation"}
                </th>
              </tr>
            </thead>
            <tbody>
              {isToday ? (
                isLoading ? (
                  <tr>
                    <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                      Loading...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                      Error: {error.message}
                    </td>
                  </tr>
                ) : (
                  resource === "cpu_system" || resource === "cpu_user" ? (
                    data.anomalies[0][resource].map((anomaly) => (
                      <tr key={anomaly.time}>
                        <td style={{ fontSize: "0.8rem" }}>
                          {anomaly.time.slice(0, 16)}
                        </td>
                        <td style={{ fontSize: "0.8rem" }}>
                          {anomaly[resource].toFixed(2)}%
                        </td>
                        <td style={{ fontSize: "0.8rem" }}>
                          {anomaly.deviation.toFixed(2)}
                        </td>
                      </tr>
                    ))
                  ) : (
                  data.anomalies.map((anomaly) => (
                    <tr key={anomaly.time}>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.time.slice(0, 16)}
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly[`${resource}_usage`].toFixed(2)}%
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.deviation.toFixed(2)}
                      </td>
                    </tr>
                  ))
                )
                )
              ) : isLoadingWeek ? (
                <tr>
                  <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                    Loading...
                  </td>
                </tr>
              ) : errorWeek ? (
                <tr>
                  <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                    Error: {errorWeek.message}
                  </td>
                </tr>
              ) : (
                resource === "cpu_system" || resource === "cpu_user" ? (
                  dataWeek.anomalies[0][resource].map((anomaly) => (
                    <tr key={anomaly.time}>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.time.slice(0, 16)}
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly[resource].toFixed(2)}%
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.deviation.toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                dataWeek.anomalies.map((anomaly) => (
                  <tr key={anomaly.time}>
                    <td style={{ fontSize: "0.8rem" }}>
                      {anomaly.time.slice(0, 16)}
                    </td>
                    <td style={{ fontSize: "0.8rem" }}>
                        {anomaly[`${resource}_usage`].toFixed(2)}%
                      
                    </td>
                    <td style={{ fontSize: "0.8rem" }}>
                      {anomaly.deviation.toFixed(2)}
                    </td>
                  </tr>
                ))
              )
              )}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );
};
